/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

@Component({
  selector: 'toggle-button',
  templateUrl: 'toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
})

export class ToggleButtonComponent implements OnInit, OnDestroy {
  @Input() icon: string;
  @Input() hint: string;
  @Input() value: boolean;
  @Input() noToggle: boolean = false;
  @Input() disabled: boolean = false;
  @Input() small: boolean = false;
  @Input() name: string;
  @Input() show: boolean = true;

  @Output() valueChange: EventEmitter<boolean> = new EventEmitter();

  constructor(

  ) {}

  ngOnInit():void {
  }

  ngOnDestroy(): void {
  }

  toggle(): void {
    if(!this.noToggle && !this.disabled){
      this.value = !this.value;
      this.valueChange.emit(this.value);
    }
  }
}
